/* src/app/component/dialogs/level-start-dialog/level-start-dialog.component.scss */
.dialog-close {
  position: absolute;
  top: 0.5rem;
  right: 1rem;
  background: transparent;
  border: none;
  cursor: pointer;
  z-index: 1;
}
.dialog-close:hover {
  opacity: 0.8;
}
/*# sourceMappingURL=level-start-dialog.component.css.map */
